import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo_band.png'


const _withScopeId = n => (_pushScopeId("data-v-f693827a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "footer_bar" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = {
  key: 0,
  class: "assets"
}
const _hoisted_4 = { class: "label" }
const _hoisted_5 = {
  key: 1,
  class: "assets"
}
const _hoisted_6 = { class: "label" }
const _hoisted_7 = {
  key: 2,
  class: "assets"
}
const _hoisted_8 = { class: "label" }
const _hoisted_9 = {
  key: 3,
  class: "assets"
}
const _hoisted_10 = { class: "label" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reverse_content" }, [
  /*#__PURE__*/_createElementVNode("span", null, "© 2024 ALC. All rights reserved.")
], -1))
const _hoisted_12 = [
  _hoisted_11
]

import provide_key from "@/constant/provide_key";
import { inject, nextTick } from "vue";
import routeHash from '@/constant/router_hash'
import { useRouter } from 'vue-router'
import Mitt from "@/utils/mitt";


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterBar',
  setup(__props) {

const router = useRouter()

const shrink: boolean | undefined = inject(provide_key.SHRINK);

const onJumpTo = (hash: any) => {
  setTimeout(() => Mitt.emit(hash), 0)
  switch(hash) {
    case routeHash.AIR_TO_LIQUID_COOLING:
    case routeHash.SYSTEMIC_LIQUID_COOLING:
    case routeHash.RDHX_AIR_COOLED:
      router.push({ path: "/solution" })
      return;
    case routeHash.IDC_LIQUID_COOLING:
    case routeHash.AIGC_INFRASTRUCTURE:
      router.push({ path: "/service" })
      return;
    case routeHash.L2A_PRODUCT:
    case routeHash.L2L_PRODUCT:
    case routeHash.RDHx_PRODUCT:
    case routeHash.OTHERS_PRODUCT:
      router.push({ path: "/product"})
      return;
    case routeHash.CONTACT_US:
      router.push({ path: "/company" })
      return;
    default: return
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "footer_content",
        style: _normalizeStyle({ 'justify-content': _unref(shrink) ? 'center' : 'space-between' })
      }, [
        _createElementVNode("div", {
          class: "left",
          style: _normalizeStyle({ 'align-items': _unref(shrink) ? 'center' : '' })
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "ALC(Air & Liquid Cooling Technology Limited (HK))",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/')))
            })
          ])
        ], 4),
        (!_unref(shrink))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("footer.SOLUTION")), 1),
              _createElementVNode("div", {
                class: "option",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (onJumpTo(_unref(routeHash).AIR_TO_LIQUID_COOLING)))
              }, _toDisplayString(_ctx.$t("footer.WIND_TO_LIQUID")), 1),
              _createElementVNode("div", {
                class: "option",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (onJumpTo(_unref(routeHash).SYSTEMIC_LIQUID_COOLING)))
              }, _toDisplayString(_ctx.$t("footer.LIQUID_COOLING")), 1),
              _createElementVNode("div", {
                class: "option",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (onJumpTo(_unref(routeHash).RDHX_AIR_COOLED)))
              }, _toDisplayString(_ctx.$t("footer.LIQUID_COOLING_REAR_DOOR")), 1)
            ]))
          : _createCommentVNode("", true),
        (!_unref(shrink))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("footer.SERVICE")), 1),
              _createElementVNode("div", {
                class: "option",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (onJumpTo(_unref(routeHash).IDC_LIQUID_COOLING)))
              }, _toDisplayString(_ctx.$t("footer.DATA_CENTER")), 1),
              _createElementVNode("div", {
                class: "option",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (onJumpTo(_unref(routeHash).AIGC_INFRASTRUCTURE)))
              }, _toDisplayString(_ctx.$t("footer.COMPUTATIONAL_EQUIPMENT")), 1)
            ]))
          : _createCommentVNode("", true),
        (!_unref(shrink))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("footer.PRODUCT")), 1),
              _createElementVNode("div", {
                class: "option",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (onJumpTo(_unref(routeHash).L2L_PRODUCT)))
              }, _toDisplayString(_ctx.$t("product.L2L_NAV")), 1),
              _createElementVNode("div", {
                class: "option",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (onJumpTo(_unref(routeHash).L2A_PRODUCT)))
              }, _toDisplayString(_ctx.$t("product.L2A_NAV")), 1),
              _createElementVNode("div", {
                class: "option",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (onJumpTo(_unref(routeHash).RDHx_PRODUCT)))
              }, _toDisplayString(_ctx.$t("product.RDHx_NAV")), 1),
              _createElementVNode("div", {
                class: "option",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (onJumpTo(_unref(routeHash).OTHERS_PRODUCT)))
              }, _toDisplayString(_ctx.$t("product.OTHERS_NAV")), 1)
            ]))
          : _createCommentVNode("", true),
        (!_unref(shrink))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("footer.ABOUT_US")), 1),
              _createElementVNode("div", {
                class: "option",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (onJumpTo(_unref(routeHash).CONTACT_US)))
              }, _toDisplayString(_ctx.$t("footer.CONTACT_US")), 1)
            ]))
          : _createCommentVNode("", true)
      ], 4)
    ]),
    _createElementVNode("div", {
      class: "reverse",
      style: _normalizeStyle({ 'text-align': _unref(shrink) ? 'center' : 'left' })
    }, _hoisted_12, 4)
  ], 64))
}
}

})